import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import CtaSection from '../../components/CtaSection/CtaSection';
import WhyUs from '../AboutUsPage/WhyUs';
import ServiceSection from "../../components/software-company-components/ServiceSection/ServiceSection";

const ServicePage = () => {
    return (
        <Fragment>
        
            <main className="page_content about-page">
                <PageTitle pageTitle={'Our Services'}  />
                <WhyUs />
                <div className="pt-130"></div>
                <ServiceSection />
            </main>
            <CtaSection />
        
            <Scrollbar />
        </Fragment>
    )
};
export default ServicePage;
